import { useMemo, useCallback } from 'react';

function useRingCalculator(numberOfRings: number, maxRadius: number) {
  const sequence = useMemo(() => [0, 6, 4, 3, 3, 3, 3, 2, 1], []);

  const sum = useCallback(
    (length: number) => {
      return sequence.slice(0, length + 1).reduce(function (previous, current) {
        return previous + current;
      }, 0);
    },
    [sequence],
  );

  const getRadius = useCallback(
    (ring: number) => {
      const total = sum(numberOfRings);
      const current = sum(ring);

      return (maxRadius * current) / total;
    },
    [maxRadius, numberOfRings, sum],
  );

  return { getRadius };
}

export default useRingCalculator;
